export default __webpack_public_path__ + "static/media/helen.4a4e71b6.png";